import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/finance/_layout")({
    component: FinanceLayout,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.finance.title"),
        };
    },
});

function FinanceLayout() {
    return <Outlet />;
}
